export const environment = {
    dateFormat: 'M/d/yyyy',
    production: false,
    timeFormat: 'h:mm a',
};
